const Navigation = {
	main: [
		{ name: "About", href: "/#about" },
		{ name: "Faq", href: "/#faq" },
		{
			name: "Opportunities",
			opportunities: [
				{
					name: "Educational Scholarships",
					value: "Scholarships",
				},
				{
					name: "Workplace  Prospects",
					value: "ITJobs",
				},
				{
					name: "Coding Challenges",
					value: "CodingContests",
				},
				//TEMPORARY FOR REVIEW ONLY
				{
					name: "Others",
					value: "Others",
				},
				{
					name: "ToReview",
					value: "ToReview",
				},
			],
		},
	],
};
export default Navigation;
